export enum blockoutTypeEnums {
  byService = 'byService',
  byTable = 'byTable',
  bySection = 'bySection',
  byTableAndSection = 'byTableAndSection',
}
export interface IBlockoutProps {
  handleModalClose: () => void;
  showBlockoutOnFp?: boolean;
  handleSaveClick: (value: blockoutTypeEnums) => void;
}
